import { render, staticRenderFns } from "./PayMannerList.vue?vue&type=template&id=8be96aca&scoped=true&"
import script from "./PayMannerList.vue?vue&type=script&lang=js&"
export * from "./PayMannerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be96aca",
  null
  
)

export default component.exports